var render = function (_h,_vm) {var _c=_vm._c;return _c('button',[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }